import React from 'react'
import AuthProvider from './src/components/Context/AuthProvider'
import CartProvider from './src/components/Context/CartProvider'

// eslint-disable-next-line import/prefer-default-export

const WrapWithProviderRoot = ({ element }) => (
	<AuthProvider>
		<CartProvider>{element}</CartProvider>
	</AuthProvider>
)

export default WrapWithProviderRoot
